import { useMutation } from '@gogame/query';

import { importMainBudgetPlanning } from 'scenes/MainBudgetPlanning/sources/mainBudgetPlanning';

import { importMainBudgetPlanning as importMainBudgetPlanningKey } from '../queryKeyFactory';

export const useImportMainBudgetPlanning = () => {
  const importMainBudgetPlanningMutation = useMutation(
    importMainBudgetPlanningKey(),
    importMainBudgetPlanning,
    {
      mutateMessage: () => 'Upload has started',
      successMessage: () => 'Upload complete',
    }
  );

  return [
    importMainBudgetPlanningMutation.mutateAsync,
    importMainBudgetPlanningMutation,
  ];
};
